import { useState } from 'react';
import { NetflixRow, NetflixCard } from './NetflixRow';
import { CardDetailModal } from './CardDetailModal';

export const ExperienceRow = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const experiences = [
    {
      title: "Google Cloud Risk & Governance",
      subtitle: "Technical Program Manager • 2022-Present",
      description: "Leading transformational risk management across Google Cloud Platform's entire ecosystem. Spearheading cross-functional risk remediation programs across CISO, Cloud AI, Databases, Infrastructure, GTM & Finance divisions. Reduced FedRAMP authorization timelines by 20% through innovative OSCAL-based machine-readable control evidence automation.",
      match: "Strategic Impact",
      tags: ["FedRAMP", "OSCAL", "AI Governance", "Cloud Security"],
      period: "September 2022 - Present",
      location: "Mountain View, CA",
      imageSrc: "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png",
      details: {
        achievements: [
          "Reduced FedRAMP authorization timelines by 20% through OSCAL automation implementation",
          "Led AI model safety governance for Gemini & GenAI products with production approval gates",
          "Oversaw Cloud Quote-to-Cash risk transformation strengthening financial controls",
          "Aligned remediation priorities with enterprise risk appetite and regulatory frameworks (FedRAMP, DORA, AI Act)",
          "Managed concentration risk mitigation under Google's 'Shared Fate' security model",
          "Coordinated cross-functional teams across 15+ product areas and 200+ engineers"
        ],
        technologies: ["OSCAL", "FedRAMP 20x", "DORA", "EU AI Act", "GCP", "Kubernetes", "Terraform", "Risk Quantification"]
      }
    },
    {
      title: "LinkedIn Information Security",
      subtitle: "Staff Manager • March 2022 - Sept 2022",
      description: "Led enterprise-wide information security governance across LinkedIn's global platform serving 800M+ professionals. Scaled Common Controls Program with 30% increased adoption across engineering teams while reducing audit preparation time by 25% through strategic automation initiatives.",
      match: "Operational Excellence",
      tags: ["ISO 27001", "SOX", "GDPR", "GRC"],
      period: "March 2022 - September 2022",
      location: "Sunnyvale, CA",
      imageSrc: "https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png",
      details: {
        achievements: [
          "30% increase in Common Controls Program adoption across engineering teams",
          "25% reduction in audit preparation time through strategic automation",
          "Managed $350K annual security budget in collaboration with GRC teams",
          "Enterprise compliance readiness for EU Data Privacy Framework, Indian Privacy Law (DPDP)",
          "End-to-end compliance implementation with ISO 27001, SOX, and GDPR frameworks",
          "Optimized resource allocation achieving maximum security ROI across global operations"
        ],
        technologies: ["ISO 27001", "SOX", "GDPR", "DPDP", "EU Cybersecurity Act", "GRC Automation"]
      }
    },
    {
      title: "Discover Financial Services",
      subtitle: "Principal Information Security (BISO) • 2017-2022",
      description: "Architected cybersecurity governance for Fortune 500 financial services organization. Negotiated $125M cyber insurance expansion while reducing premiums by $50K. Achieved 30% improvement in early fraud detection through Red Flags Identity Theft Prevention controls. Secured NYDFS cybersecurity approval with zero findings.",
      match: "Risk Leadership",
      tags: ["NYDFS", "Financial Controls", "Cyber Insurance", "Risk Quantification"],
      period: "June 2017 - March 2022",
      location: "Chicago, IL",
      imageSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Discover_Card_logo.svg/2560px-Discover_Card_logo.svg.png",
      details: {
        achievements: [
          "$125M cyber insurance expansion negotiated with $50K premium reduction",
          "30% improvement in early fraud detection and account protection mechanisms",
          "Zero findings achieved in NYDFS cybersecurity approval for new banking entity",
          "EML/PML-based cyber risk quantification frameworks developed for board-level decisions",
          "Cross-border privacy and cybersecurity compliance execution across international markets",
          "Nation-state threat coverage expansion through strategic insurance negotiations"
        ],
        technologies: ["NYDFS", "Red Flags Rule", "EML/PML", "Financial Controls", "Risk Analytics", "Cyber Insurance"]
      }
    }
  ];

  const handleCardClick = (experience) => {
    setSelectedCard(experience);
    setModalOpen(true);
  };

  return (
    <>
      <NetflixRow title="Leadership Experience" id="experience">
        {experiences.map((exp, index) => (
          <NetflixCard
            key={index}
            title={exp.title}
            subtitle={exp.subtitle}
            description={exp.description}
            match={exp.match}
            tags={exp.tags}
            imageSrc={exp.imageSrc}
            onClick={() => handleCardClick(exp)}
          />
        ))}
      </NetflixRow>
      
      <CardDetailModal 
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        card={selectedCard}
        type="experience"
      />
    </>
  );
};